// extracted by mini-css-extract-plugin
export var compactFilters = "_c2-4";
export var detailImage = "_c2-1";
export var dropdownContainer = "_c2-2";
export var imageContainer = "_c2-0";
export var selectedCard = "_c2-3";